// extracted by mini-css-extract-plugin
export default {"detail_container":"CustomerEdit_detail_container__a3cet","title":"CustomerEdit_title__CraF7","button":"CustomerEdit_button__0LLqN"};